export const previewSidebar = {
  openPreviewSidebar: 'Otwórz podgląd modeli',
  noModelAssigned: 'Opcja nie posiada przypisanego modelu',
  noStepsInStage: 'Brak opcji przypisanych do kroku!',
  noOptionInSteps: 'Brak kroków przypisanych do etapu!',
  preview: 'Podgląd',
} as const
